import { render } from "./AnomalyBanner.vue?vue&type=template&id=0bce740c"
import script from "./AnomalyBanner.vue?vue&type=script&lang=js"
export * from "./AnomalyBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__